export default __webpack_public_path__ + "static/media/patwin-hut.f099eeb4.jpg";